import { css } from 'styled-components';
import {
  getThemeProp,
  gray,
  themeColor,
  spacer,
  multiply,
  fontSize,
  mediaBreakpointUp,
} from '@whitelabel/helpers/style';

const globalFormStyle = css`
  .form-control {
    height: ${multiply(spacer, 2.6875)};
    padding: ${multiply(spacer, 0.5)} ${multiply(spacer, 0.75)};
    font-size: ${multiply(fontSize('base'), 1.125)};
    border-color: ${gray(500)};

    ${mediaBreakpointUp('md')`
      padding: ${multiply(spacer, 0.5)} ${spacer};
    `}

    ${mediaBreakpointUp('lg')`
      height: ${multiply(spacer, 2.875)};
      font-size: ${fontSize('lg')};
    `}
    
    &.is-invalid {
      padding-right: 0.9375rem;
      padding-left: 0.9375rem;
      background-image: none;
      border-color: ${themeColor('danger')};
    }

    &:disabled {
      background-color: ${gray(300)};
    }

    &:focus {
      border-color: ${gray(700)};
      box-shadow: none;
    }
  }

  .custom-control-input {
    width: 1.25rem;
    &:focus ~ .custom-control-label::before {
      box-shadow: none;
    }

    &:focus:not(:checked) ~ .custom-control-label::before {
      border-color: ${gray(700)};
    }

    &:checked ~ .custom-control-label::before {
      background-color: ${themeColor('primary')};
    }
  }

  .custom-control-label:after,
  .custom-control-label:before {
    left: -1.75rem;
    width: 1.25rem;
    height: 1.25rem;
  }

  .text-muted {
    color: ${gray(600)};
  }

  .form-control[readonly],
  .form-control:disabled,
  .form-control-plaintext {
    direction: inherit;
    border-color: ${getThemeProp('inputDisabledBG')};

    &:focus {
      border-color: ${getThemeProp('inputDisabledBG')};
    }
  }

  .form-text {
    display: block;
  }

  .invalid-feedback {
    color: ${themeColor('danger')};
  }

  .input-group-append,
  .input-group-prepend {
    display: flex;
  }

  .input-group > .form-control,
  .input-group > .form-select {
    flex: 1 1;
    width: 100vw;
  }
`;

export default globalFormStyle;
